import useSearch, { SearchProvider } from "./context";

export default useSearch;

export { SearchProvider };
